import { VALUE_DATA_ATTRIBUTE } from './constants';
export function isEventTargetDay(event) {
    return (event.target instanceof HTMLElement &&
        !!event.target.getAttribute(VALUE_DATA_ATTRIBUTE));
}
//# sourceMappingURL=eventUtils.js.map